var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftHeroImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.27 70.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6cc5ed;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "White LogoAsset 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.05,58.82H54.5a.65.65,0,0,1-.66-.66.66.66,0,0,1,.66-.67h2.89v-17a.65.65,0,0,1,.66-.66.66.66,0,0,1,.67.66v17.7A.66.66,0,0,1,58.05,58.82Zm-7.09,0H29.71a.65.65,0,0,1-.66-.66.66.66,0,0,1,.66-.67H51a.66.66,0,0,1,.66.67A.65.65,0,0,1,51,58.82Zm-24.79,0H12a.66.66,0,0,1-.66-.66v-7.1a.67.67,0,0,1,1.33,0v6.43H26.17a.67.67,0,0,1,.66.67A.66.66,0,0,1,26.17,58.82ZM12,48.18a.66.66,0,0,1-.66-.66V26.27a.67.67,0,0,1,1.33,0V47.52A.66.66,0,0,1,12,48.18Zm46-10.6a.66.66,0,0,1-.66-.66V15.67a.66.66,0,0,1,.66-.67.67.67,0,0,1,.67.67V36.92A.67.67,0,0,1,58.05,37.58ZM12,23.39a.66.66,0,0,1-.66-.66V12.12a.67.67,0,0,1,.66-.66H33.26a.67.67,0,1,1,0,1.33H12.68v9.94A.66.66,0,0,1,12,23.39Zm46-10.6H36.81a.67.67,0,1,1,0-1.33H58.05a.67.67,0,1,1,0,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.45,54H44a.67.67,0,1,1,0-1.33h8.75V41.52a.67.67,0,1,1,1.33,0V53.35A.67.67,0,0,1,53.45,54Zm-13,0H19.23a.67.67,0,0,1,0-1.33H40.48a.67.67,0,1,1,0,1.33ZM16.83,52.88a.67.67,0,0,1-.67-.67V31a.67.67,0,0,1,1.33,0V52.21A.67.67,0,0,1,16.83,52.88ZM53.45,38.64a.67.67,0,0,1-.67-.66V17a.66.66,0,0,1-.61.41H30.92a.67.67,0,0,1,0-1.33H52.17a.68.68,0,0,1,.64.48.66.66,0,0,1,1.3.19V38A.67.67,0,0,1,53.45,38.64ZM16.83,28.09a.67.67,0,0,1-.67-.67V16.73a.67.67,0,0,1,.67-.67H27.38a.67.67,0,0,1,0,1.33H17.49v10A.67.67,0,0,1,16.83,28.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.14,17.39a.67.67,0,0,1-.67-.66l-.1-9.2a.68.68,0,0,1,.38-.61L42,3.38a.66.66,0,0,1,.59,1.19L35.71,7.93l.09,8.79a.66.66,0,0,1-.66.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.26,42.94a.68.68,0,0,1-.6-.38l-3.31-6.85-8.9.09h0a.67.67,0,1,1,0-1.33l9.32-.1h0a.66.66,0,0,1,.6.38L66.86,42a.66.66,0,0,1-.31.88A.59.59,0,0,1,66.26,42.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,8.18a.66.66,0,0,1-.3-.07l-7-3.52a.66.66,0,1,1,.59-1.19l7,3.53a.66.66,0,0,1,.3.89A.66.66,0,0,1,35,8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.76,35.7a.59.59,0,0,1-.29-.07.66.66,0,0,1-.3-.89l3.48-7a.66.66,0,0,1,1.19.59l-3.48,7A.66.66,0,0,1,62.76,35.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.25,17.39a.7.7,0,0,1-.37-.11.66.66,0,0,1-.19-.92l9.2-13.81a.63.63,0,0,1,.56-.3l4.65,0a.66.66,0,0,1,.66.67.67.67,0,0,1-.66.66h0l-4.3,0-9,13.52A.67.67,0,0,1,44.25,17.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.33,58.74h0a.66.66,0,0,1-.66-.67l0-4.26L53.08,44.9a.67.67,0,0,1-.19-.92.66.66,0,0,1,.92-.19L67.72,52.9a.65.65,0,0,1,.3.56l0,4.62A.67.67,0,0,1,67.33,58.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.19,66.93a.82.82,0,0,1-.29-.07l-7.15-3.5a.66.66,0,0,1-.38-.6V53.55a.67.67,0,0,1,1.33,0v8.8l6.79,3.32a.67.67,0,0,1-.3,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,42.94a.65.65,0,0,1-.29-.07.66.66,0,0,1-.3-.89l3.54-7.24a.67.67,0,0,1,.6-.37h9.31a.67.67,0,0,1,0,1.33H7.93L4.57,42.57A.67.67,0,0,1,4,42.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,66.94a.66.66,0,0,1-.3-1.25l7.05-3.52a.66.66,0,1,1,.59,1.19l-7,3.51A.59.59,0,0,1,28,66.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.52,35.7a.67.67,0,0,1-.6-.37l-3.52-7a.66.66,0,1,1,1.19-.59l3.52,7.05a.66.66,0,0,1-.3.89A.59.59,0,0,1,7.52,35.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.62,68H9.82a.67.67,0,0,1,0-1.33h6.44L24.08,55a.67.67,0,0,1,.92-.18.66.66,0,0,1,.19.92l-8,12A.66.66,0,0,1,16.62,68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.92,25.32a.69.69,0,0,1-.36-.11l-12-8a.65.65,0,0,1-.3-.55V9.82a.67.67,0,0,1,1.33,0v6.45L15.29,24.1a.67.67,0,0,1,.19.92A.66.66,0,0,1,14.92,25.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.25,44.81h-3a.67.67,0,1,1,0-1.33h2.36V25.93a.67.67,0,1,1,1.33,0V44.15A.67.67,0,0,1,44.25,44.81Zm-6.58,0H26a.67.67,0,0,1-.67-.66V34.54a.67.67,0,1,1,1.33,0v8.94h11a.67.67,0,1,1,0,1.33ZM26,31.66a.67.67,0,0,1-.67-.67V25.93a.67.67,0,0,1,.67-.67H42.22a.67.67,0,0,1,0,1.33H26.7V31A.67.67,0,0,1,26,31.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.64,39.06H30.43a.66.66,0,1,1,0-1.32h9.21a.66.66,0,1,1,0,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.64,32.54H30.43a.67.67,0,0,1-.66-.67.66.66,0,0,1,.66-.66h9.21a.66.66,0,0,1,.67.66A.67.67,0,0,1,39.64,32.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.93,5.93a3,3,0,1,1,3-3A3,3,0,0,1,25.93,5.93Zm0-4.6A1.64,1.64,0,1,0,27.57,3,1.63,1.63,0,0,0,25.93,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.34,5.93a3,3,0,1,1,3-3A3,3,0,0,1,44.34,5.93Zm0-4.6A1.64,1.64,0,1,0,46,3,1.63,1.63,0,0,0,44.34,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.26,47.31a3,3,0,1,1,3-3A3,3,0,0,1,67.26,47.31Zm0-4.6a1.64,1.64,0,1,0,1.64,1.63A1.64,1.64,0,0,0,67.26,42.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.76,5.93a3,3,0,1,1,3-3A3,3,0,0,1,62.76,5.93Zm0-4.6A1.64,1.64,0,1,0,64.4,3,1.64,1.64,0,0,0,62.76,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.31,65.73a3,3,0,1,1,3-3A3,3,0,0,1,67.31,65.73Zm0-4.61a1.64,1.64,0,1,0,1.63,1.64A1.64,1.64,0,0,0,67.31,61.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.52,70.27a3,3,0,1,1,3-3A3,3,0,0,1,7.52,70.27Zm0-4.59a1.63,1.63,0,1,0,1.64,1.63A1.64,1.64,0,0,0,7.52,65.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,10.48a3,3,0,1,1,3-3A3,3,0,0,1,3,10.48Zm0-4.6A1.64,1.64,0,1,0,4.61,7.52,1.64,1.64,0,0,0,3,5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.93,70.27a3,3,0,1,1,3-3A3,3,0,0,1,25.93,70.27Zm0-4.59a1.63,1.63,0,1,0,1.64,1.63A1.63,1.63,0,0,0,25.93,65.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,28.9a3,3,0,1,1,3-3A3,3,0,0,1,3,28.9Zm0-4.6a1.64,1.64,0,1,0,1.64,1.63A1.63,1.63,0,0,0,3,24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,47.31a3,3,0,1,1,3-3A3,3,0,0,1,3,47.31Zm0-4.6a1.64,1.64,0,1,0,1.64,1.63A1.63,1.63,0,0,0,3,42.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.25,70.27a3,3,0,1,1,3-3A3,3,0,0,1,44.25,70.27Zm0-4.59a1.63,1.63,0,1,0,1.64,1.63A1.63,1.63,0,0,0,44.25,65.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.26,28.9a3,3,0,1,1,3-3A3,3,0,0,1,67.26,28.9Zm0-4.6a1.64,1.64,0,1,0,1.64,1.63A1.64,1.64,0,0,0,67.26,24.3Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftHeroImg);
export default __webpack_public_path__ + "static/media/left-hero-img.3f58285a5301f9028794b8adf39d879f.svg";
export { ForwardRef as ReactComponent };